module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("CHAMPION OF")]), _vm._v(" the Gods began with a wizard, a warrior, and two unicorns thirteen years ago, and if not my husband Michael’s encouragement, it would be another file in my hard drive. Many great people have had a hand helping me realize my dream of seeing Champion of the Gods into print and audio. I can’t name them all, but a few need to be mentioned and thanked:")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Elizabeth North—for taking a chance on me and always giving me more than I deserve. This book, and the entire series, owes its life in the world to you.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Anne Regan—editors get so little credit, but they deserve so much. I would be dreadful without you and your steady hand and your incredible patience.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Samantha—for the amazing covers and for knowing what my vision was before I knew it myself.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("The entire DSP Publications staff—without you and your amazing work behind the scenes to make our dreams come true, there would be nothing. My eternal thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And to the readers—for being part of the journey. Without you, the road would be a lonely place.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("To read more about the Champion of the Gods universe, please visit my website. In addition to people, places, and things, there are videos, artwork, and free short stories you can download that add depth and texture to the series.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("For more information, please visit:")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("http://www.andrewqgordon.com/champion-of-the-gods/")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9946313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0005.vue
// module id = 69
// module chunks = 0